import { Tag } from 'antd';
import { useIntl } from 'react-intl';

import type { TWorkJourneyManagementJourneyMonthStatusType } from '@src/models/interfaces/workJourneyManagement.interface';
import IntlMessages from '@src/util/IntlMessages';

import styles from './styles.module.less';

interface WorkJourneyMonthStatusBadgeProps {
  type: TWorkJourneyManagementJourneyMonthStatusType;
  dayCount?: number;
}

const STATUS_COLORS: Record<TWorkJourneyManagementJourneyMonthStatusType, string> = {
  below_minimum: 'error',
  scheduled_absences: 'gold',
  staffing_shortage: 'error',
  rejections: 'purple',
  on_track: 'success',
};

const OUTLINED_STATUSES: TWorkJourneyManagementJourneyMonthStatusType[] = ['staffing_shortage'];

export const WorkJourneyMonthStatusBadge = ({ type, dayCount }: WorkJourneyMonthStatusBadgeProps) => {
  const intl = useIntl();
  const isOutlined = OUTLINED_STATUSES.includes(type);
  const dayCountLabel =
    dayCount != null
      ? intl.formatMessage(
          { id: 'workJourney.management.journeyStatus.dayCount' },
          { count: dayCount },
        )
      : null;

  return (
    <Tag
      color={isOutlined ? undefined : STATUS_COLORS[type]}
      className={`gx-mb-0 gx-mr-0 ${styles.badge} ${isOutlined ? styles.outlined : ''}`}
    >
      <IntlMessages id={`workJourney.management.journeyStatus.${type}`} />
      {dayCountLabel ? ` · ${dayCountLabel}` : null}
    </Tag>
  );
};
